import { RootState } from "../reducers";
import ReducerFactory from "src/ipm-shared/Utils/ReduxReducer";
import notifications from "./reducers";
ReducerFactory.registerReducer({ notifications });

// Notifications
export const getNotificationsCount = (state: RootState) =>
  Object.keys(state.notifications.byId).length;
